import { render, staticRenderFns } from "./UpgradePlansV2.vue?vue&type=template&id=4abbd28f"
import script from "./UpgradePlansV2.vue?vue&type=script&lang=js"
export * from "./UpgradePlansV2.vue?vue&type=script&lang=js"
import style0 from "./UpgradePlansV2.vue?vue&type=style&index=0&id=4abbd28f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports